<template>
    <d-select-search-stable
        :id="id"
        v-model="localValue"
        :list="regionsList"
        :placeholder="placeholder"
        :is-error="isError"
        :is-loading="isLoading"
        :searchable="searchable"
        :disabled="isLoading"
        :single-line="singleLine"
        :dark="dark"
    />
</template>
<script>
import { getRegionsV2 } from '../../assets/js/utils';
import memoize from 'lodash/memoize';
import { dadataApi } from '../../assets/js/vue/utlis/useDadata';

export default {
    name: 'UiBankRegionPicker',
    props: {
        id: String,
        placeholder: String,
        value: Number,
        isError: Boolean,
        searchable: Boolean,
        /** автоматически подставляет регион по ip пользователя, использует дадату */
        autodetect: Boolean,
        /** если false - то значение вертикально по центру, если true - то значение будет прижато к низу */
        singleLine: Boolean,
        valueCode: String,
        dark: Boolean,
    },
    data() {
        return {
            regionsList: [],
            localValue: undefined,
            isLoading: false,
        };
    },
    watch: {
        value: {
            handler(val) {
                this.localValue = val;
            },
            immediate: true,
        },
        valueCode: {
            async handler(val) {
                await this.getRegionsListMemoized();
                this.localValue = this.regionsList.find((item) => item.code === val)?.const;
            },
        },
        localValue: {
            async handler(val) {
                if (val !== this.value) this.$emit('input', val);

                await this.getRegionsListMemoized();
                this.$emit('update:object', this.getObjectValue());

                const subjectCode = this.getObjectValue()?.code;
                if (subjectCode !== this.valueCode) this.$emit('update:value-code', subjectCode);

            },
        },
    },
    computed: {
        requestId() {
            return `getAllRegionsV2-${this._uid}`;
        },
    },
    methods: {
        async fetchRegionsList() {
            this.isLoading = true;
            try {
                const { data: { data: items } } = await getRegionsV2(undefined, undefined, { key: this.requestId });

                items.sort((a, b) => {
                    if (a.attributes.name.toLowerCase() > b.attributes.name.toLowerCase()) {
                        return 1;
                    }
                    if (a.attributes.name.toLowerCase() < b.attributes.name.toLowerCase()) {
                        return -1;
                    }
                    return 0;
                });

                this.regionsList = items.map((item) => ({
                    const: item.id,
                    title: item.attributes.name,
                    code: item.attributes.code,
                }));
            } catch (e) {
                this.regionsList = [];
            }
            this.isLoading = false;
            return this.regionList;
        },
        getObjectValue() {
            return this.regionsList.find((item) => item.const === this.localValue);
        },
        async detectRegion() {
            let regionNormalized;

            try {
                const { data: { location: { data: { region_with_type }}} } = await dadataApi.getLocationByIp();
                regionNormalized = region_with_type?.toLowerCase();
            } catch (e) {
                //
            }

            if (!regionNormalized) {
                return;
            }

            this.localValue = this.regionsList.find((item) => item.title.toLowerCase() === regionNormalized)?.const;
        },
    },
    async created() {
        this.getRegionsListMemoized = memoize(this.fetchRegionsList);

        await this.getRegionsListMemoized();

        if (!this.value && this.valueCode) this.localValue = this.regionsList.find((item) => item.code === this.valueCode)?.const;

        if (this.autodetect) this.detectRegion();
    },
};
</script>
<style lang="scss">

</style>
